import React, { useEffect, useRef } from 'react';
import { KilobaRacingGame } from '../phaser/games/kiloba-racing';
import '../pages/KilobaRacingPage.css';

interface KilobaRacingGameComponentProps {
  onGameEnd?: (result: any) => void;
  gameSessionId?: string; // Add this prop for event mode
}

export const KilobaRacingGameComponent: React.FC<KilobaRacingGameComponentProps> = ({ 
  onGameEnd,
  gameSessionId 
}) => {
  const gameRef = useRef<HTMLDivElement>(null);
  const phaserGameRef = useRef<KilobaRacingGame | null>(null);

  useEffect(() => {
    if (gameRef.current && !phaserGameRef.current) {
      // Store gameSessionId in session storage for event mode detection
      if (gameSessionId) {
        sessionStorage.setItem('gameSessionId', gameSessionId);
      }
      
      // Store onGameEnd callback in global scope for Phaser game to access
      if (onGameEnd) {
        (window as any).onGameEndCallback = onGameEnd;
      }
      
      // Initialize the Phaser game
      phaserGameRef.current = new KilobaRacingGame(gameRef.current);
    }

    return () => {
      // Cleanup when component unmounts
      if (phaserGameRef.current) {
        phaserGameRef.current.destroy();
        phaserGameRef.current = null;
      }
      
      // Clear gameSessionId from session storage when game component unmounts
      // (only if this component set it)
      if (gameSessionId) {
        sessionStorage.removeItem('gameSessionId');
      }
      
      // Clear onGameEnd callback
      if (onGameEnd) {
        delete (window as any).onGameEndCallback;
      }
    };
  }, [gameSessionId]);

  return (
    <div 
      ref={gameRef} 
      className="kiloba-racing-game-container"
    />
  );
};
